import React, { FC, useCallback, useMemo, useState } from 'react';
import {
  getLocalStorage as getLocalStorageUtil,
  setLocalStorage as setLocalStorageUtil,
} from 'common/utils/local-storage/local-storage';
import { CaloriesContext } from './CaloriesContext';

interface CaloriesProviderValue {
  userCaloriesEnabled: boolean;
  toggleCalories?: () => void;
}

export const CaloriesProvider: FC = ({ children }) => {
  const [userCaloriesEnabled, setUserCaloriesEnabled] = useState<boolean>(() => {
    const enabled = getLocalStorageUtil('caloriesEnabled');

    if (enabled === null) {
      setLocalStorageUtil('caloriesEnabled', true);
    }

    return getLocalStorageUtil('caloriesEnabled');
  });

  const toggleCalories = useCallback(() => {
    setUserCaloriesEnabled(!userCaloriesEnabled);
    setLocalStorageUtil('caloriesEnabled', !userCaloriesEnabled);
  }, [userCaloriesEnabled]);

  const contextValue: CaloriesProviderValue = useMemo(
    () => ({
      userCaloriesEnabled,
      toggleCalories,
    }),
    [userCaloriesEnabled, toggleCalories]
  );

  return <CaloriesContext.Provider value={contextValue}>{children}</CaloriesContext.Provider>;
};
